export const TWISM_COUNTRIES_LOCAL_STORAGE_KEY =
  '@twism:internationalization.countries';

export enum ELanguages {
  EN_US = 'en-US',
  PT_PT = 'pt-pt',
  ES = 'es',
  FR = 'fr',
  DE = 'de',
  IT = 'it',
  JA = 'ja'
}

export enum ECountries {
  UnitedStates = 'United States',
  Canada = 'Canada',
  UnitedKingdom = 'United Kingdom',
  India = 'India'
}

export enum EUnavailableStatus {
  COMING_SOON = 'coming_soon',
  UNDATED = 'undated'
}

export enum EFeaturesStatuses {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  FULL_ACCESS = 'full-access',
  ONLINE = 'online',
  BETA = 'beta'
}

export type FeatureStatus = EFeaturesStatuses | null;

export interface IInternationalizationFeaturesStatuses {
  isInitialized: boolean;
  loyalty: FeatureStatus;
}

export enum EInternationalizationStatus {
  FULL = 'full',
  ONLINE_ONLY = 'online_only',
  UNDATED = 'undated'
}

export type IInternationalizationStatus =
  | 'full'
  | 'beta'
  | 'online_only'
  | 'undated'
  | 'coming_soon';

export interface IInternationalization {
  countryIso2: string;
  langCode: string;
  name: string;
  phoneMask: string;
  phoneCode: string;
  currency: string;
  currencySign?: string;
  currencySymbol: string;
  currencyName: string;
  currencyShorthand: string;
  dateFormat?: string;
  enabled?: boolean;
  status?: IInternationalizationStatus;
}

export interface IInternationalizationIntegration {
  id: string;
  provider: string;
  status: 'inactive' | 'active';
  country: {
    id: string;
    name: string;
  };
}

export type TInternalizationIntegrations = IInternationalizationIntegration[];
